import {
  FETCH_CIRCLE_POST,
  FETCH_CIRCLE_POST_SUCCESS,
  FETCH_CIRCLE_POST_FAILED,
  FETCH_CIRCLE_POST_SEARCH,
  FETCH_CIRCLE_POST_SEARCH_SUCCESS,
  FETCH_CIRCLE_POST_SEARCH_FAILED,
} from "../actions/actionTypes";

const initialState = {
  isLoading: true,
  isSearching: false,
  content: {},
  blogs: [],
  error: false,
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_CIRCLE_POST:
      return {
        ...state,
        isLoading: true,
        content: {},
        // blogs: []
      };
    case FETCH_CIRCLE_POST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        content: payload,
        // blogs: payload.blogs
      };
    case FETCH_CIRCLE_POST_FAILED:
      return {
        ...state,
        isLoading: false,
        content: {},
        // blogs: [],
        error: payload,
      };
    case FETCH_CIRCLE_POST_SEARCH:
      return {
        ...state,
        isSearching: true,
      };
    case FETCH_CIRCLE_POST_SEARCH_SUCCESS:
      return {
        ...state,
        isSearching: false,
        isLoading: false,
        content: {
          ...state.content,
          ...payload,
        },
      };

    case FETCH_CIRCLE_POST_SEARCH_FAILED:
      return {
        ...state,
        isSearching: false,
        error: payload,
      };
    default:
      return state;
  }
}
